import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import firebase from "firebase/app";
import 'firebase/firestore';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import CreateIcon from '@material-ui/icons/Create';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import { keys } from '@material-ui/core/styles/createBreakpoints';



const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
 
  
  avatar: {
    backgroundColor: red[500],
  },
}));


     
    
  
  
export default function RecipeReviewCard(props) {
  const[chave, setachave]=React.useState();

    React.useEffect (()=>{
        setachave(props.value);
console.log('valor da chave ps', chave)
    },[])

console.log('valor da chave ps2', chave)

const[estado1, seta1]=React.useState(true);
  const[estado2, seta2]=React.useState(false);
  var [passageiro, setapassageiro]=React.useState(
    {nome:'', siapemat:'', telefone:''}
  );
  const[siapemat, setsiapemat]=React.useState('');
  const[nomeps,setnomeps]=React.useState('');
  const [phone, setphone]=React.useState('');

  async function btnslv(){


    /*var nome = document.getElementById("nomeps").value;
    console.log("nomeps ", nome)
    var siapemat = document.getElementById("SIAPE").value;
    console.log("siapemat ", siapemat);
    var telefone = document.getElementById("telefone").value;
    console.log("fone ", telefone);*/


    //setapassageiro({...passageiro,[passageiro.nome]:nome});
    //setapassageiro(passageiro => ({passageiro, nome: nome}));
    //setapassageiro({...passageiro,[passageiro.nome]: "nome"});
    passageiro=({nome:nomeps,siapemat:siapemat, telefone:phone});
    console.log("passageiros ", passageiro);
    console.log("chavessss ", chave);

      props.setstatelistapassageiro(estado=>[...estado,{passageiro}])
      //  props.setstatelistapassageiro({passageiro: [...passageiro, {passageiro,chave}]});
    handleestado()
  }

  async function btnremove(){
    //props.onChildparadaChanged({chave});
    var list = props.statelistapassageiro.filter(parada=>parada.chave!== chave);
    var list2=props.statepassageiro.filter(parada=>parada.chave!== chave);
    //console.log('lista ' , list)
    //
    props.setstatelistapassageiro(list);
    props.setstatepassageiro(list2);
    //{people.filter(person => person.age < 60)

  }

  const handleestado=()=> (
      seta1(false),
  
  seta2(true)
  )


//********************objeto passageiro******************* */

const [itemuser, setitemuser] = React.useState([]);


   
     
  
 
 
      //********************************************************************** */


  const classes = useStyles();
  
  
  return (
    <Card className={classes.root} >
           <CardHeader
             avatar={
               
               <Avatar aria-label="Veículo" className={classes.avatar}>
                <AccountCircleIcon />
               </Avatar>
             }
            
             title= "Passageiro"
                 
     
           />
            <CardContent>
              <form id="foms" onSubmit={btnslv} noValidate={false}>
            <TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setnomeps(e.target.value)}
                   required
                   type="nome"
                   fullWidth
                   id="nomeps"
                   label="Nome"
                   name="nome"
                   disabled={estado2}
                   
                   
                 />
          
          
                          <TextField
                           
                           variant="outlined"
                           margin="normal"
                          onChange={ e=>setsiapemat(e.target.value)}
                           required
                           type="Number"
                           fullWidth
                           id="SIAPE"
                           label="SIAPE/Mátricula"
                           name="SIAPE"
                           disabled={estado2}
                           
                           
                           />   
                     
                     <TextField
                   variant="outlined"
                   margin="normal"
                   onChange={ e=>setphone(e.target.value)}
                   required
                   type="Number"
                   fullWidth
                   id="telefone"
                   label="Telefone"
                   name="telefone"
                   disabled={estado2}
                   
                   
                   
                 />  
                 </form>      

      </CardContent>
          
            <CardActions disableSpacing>
           
            <IconButton  id="btsalvar" aria-label="Remover" value={chave} key={chave} 
            onClick={btnremove}
            
            /*onClick={key => {
                props.onChildChanged({ chave} );
              }}*/
            >
                    <DeleteIcon />
                  </IconButton>
                     
                  <IconButton  alignItems ="right" id="btsalvar" aria-label="Salvar" disabled={estado2}
                        
                        onClick={btnslv}
                          
                        >
                                <SaveIcon />
                              </IconButton> 
             
     
           </CardActions>
           
         </Card>
  );
}